<template>
  <section class="componenets-categories">
    <div class="desktop-mode mr-3" @mouseover="isOpen = true" @mouseleave="leaveMenu">
      <div class="categories-btn d-flex">
        <button
          type="button"
          :class="{'tcon-transform':isOpen}"
          class="tcon tcon-grid tcon-grid--rearrange"
          aria-label="toggle grid"
        >
          <span class="tcon-grid__item" aria-hidden="true"></span>
          <span class="tcon-visuallyhidden">toggle grid</span>
        </button>
        <p class="title pr-3">دسته بندی ها</p>
        <div class="categories-list">
          <ul>
            <li
              v-for="(item,index) in menuCategoreis"
              :key="index"
              :class="{active:item.isActive}"
              @click="onHover(item,index)"
              @mouseover="hover(item,index)"
              @mouseleave="onHover(item,index)"
            >
              <router-link to="/">
                <i class="flaticon-multi-tab"></i>
                <p>{{item.category}}</p>
                <i class="flaticon-left-arrow"></i>
              </router-link>
              <div class="subItem">
                <div class="d-flex flex-row justify-content-between">
                  <ul>
                    <li v-for="(sub,i) in item.sub" :key="i" @click="closeMenu(index)">
                      <router-link
                        :to="'/courses/'+item.en_category+'/'+sub.en_subcategory+'/'+sub.id"
                      >
                        <i class="flaticon-multi-tab"></i>
                        <p>{{sub.subcategory}}</p>
                      </router-link>
                    </li>
                  </ul>
                  <!-- <ul>
                    <li v-for="(item,index) in 6" :key="index">
                      <a href="">
                        <i class="flaticon-multi-tab"></i>
                        <p>{{Math.random()}}</p>
                      </a>
                    </li>
                  </ul>-->
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mobile-mode">
      <div :class="['overwrapper-mobile-mode',{open:isOpen}]"></div>
      <button
        @click="toggleMenu"
        type="button"
        :class="{'tcon-transform':isOpen}"
        class="tcon tcon-grid tcon-grid--rearrange"
        aria-label="toggle grid"
      >
        <span class="tcon-grid__item" aria-hidden="true"></span>
        <span class="tcon-visuallyhidden">toggle grid</span>
      </button>
      <div :class="['list',{open:isOpen}]">
        <collapsCategories @coloseOpen="isOpen=false"/>
      </div>
    </div>
  </section>
</template>

<script>
import collapsCategories from "cp/min-component/collaps-categories.vue";

export default {
  name: "categories",
  components: {
    collapsCategories
  },
  data() {
    return {
      isOpen: false,
      subItems: [
        { isActive: true },
        { isActive: false },
        { isActive: false },
        { isActive: false },
        { isActive: false },
        { isActive: false },
        { isActive: false },
        { isActive: false }
      ]
    };
  },
  computed: {
    windowWidth() {
      return this.$store.state.layout.windowWidth;
    },
    isMobile() {
      return this.windowWidth < 992;
    },
    menuCategoreis() {
      return this.$store.state.categories.filterCat;
    }
  },
  watch: {
    isMobile(val) {
      if (!val) {
        this.isOpen = false;
      }
    }
  },

  mounted() {
    this.$store.dispatch("categories/getCategories");
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    hover(item, index) {
      if (!this.menuCategoreis.length) return;
      this.$set(this.menuCategoreis[index], "isActive", true);
    },
    onHover(item, index) {
      if (!this.menuCategoreis.length) return;
      this.$set(this.menuCategoreis[index], "isActive", false);
    },
    closeMenu(i) {
      this.$set(this.menuCategoreis[i], "isActive", false);
      this.isOpen = false;
    },
    leaveMenu() {
      if (!this.menuCategoreis.length) return;
      this.isOpen = false;
      this.$set(this.menuCategoreis[0], "isActive", true);
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../../assets/css/variable.less";
@colorBtn: #444;
@textColor: #111;
@iconColor: #222;
@iconHover: #444;
.mobile-mode {
  display: none;
}
.componenets-categories {
  position: relative;
  .box-clear;
  .categories-btn {
    cursor: pointer;
    min-width: 130px;
  }
  .title {
    cursor: pointer;
    display: block;
    margin-bottom: 0;
    text-align: right;
    line-height: 60px;
    vertical-align: text-top;
    padding-right: 5px;
    width: 100%;
    @media screen and (max-width: 1200px) {
      font-size: 12px;
    }
  }
  .tcon {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: none;
    cursor: pointer;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background: transparent;
    outline: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-tap-highlight-color: transparent;
  }
  .tcon > * {
    display: block;
  }
  .tcon:hover,
  .tcon:focus {
    outline: none;
  }
  .tcon::-moz-focus-inner {
    border: 0;
  }

  .tcon-grid .tcon-grid__item {
    width: 0.4rem;
    height: 0.4rem;
    background: @colorBtn;
    color: @colorBtn;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  .tcon-grid.tcon-transform .tcon-grid__item {
    -webkit-transform: rotate3d(0, 0, 1, -45deg) scale3d(0.8, 0.8, 0.8);
    transform: rotate3d(0, 0, 1, -45deg) scale3d(0.8, 0.8, 0.8);
  }

  .tcon-grid--rearrange .tcon-grid__item {
    box-shadow: -0.625rem -0.625rem @colorBtn, 0 -0.625rem @colorBtn,
      0.625rem -0.625rem, -0.625rem 0 @colorBtn, 0.625rem 0 @colorBtn,
      -0.625rem 0.625rem @colorBtn, 0 0.625rem @colorBtn,
      0.625rem 0.625rem @colorBtn;
  }

  .tcon-grid--rearrange.tcon-transform .tcon-grid__item {
    box-shadow: 0 -0.5rem @colorBtn, 0 -1rem @colorBtn, 0.5rem 0 @colorBtn,
      -1rem 0 @colorBtn, 1rem 0 @colorBtn, -0.5rem 0 @colorBtn, 0 1rem @colorBtn,
      0 0.5rem;
  }

  .tcon-visuallyhidden {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  .tcon-visuallyhidden:active,
  .tcon-visuallyhidden:focus {
    clip: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    position: static;
    width: auto;
  }

  .categories-list {
    position: absolute;
    right: 0;
    left: 0;
    top: 60px;
    border-top: none;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.4);
    z-index: 8;
    background-color: #fff;
    text-align: center;
    display: none;
    min-height: 250px;
    width: 250px;
    ul {
      margin-bottom: 0;
      li {
        text-align: center;
        // position: relative;
        a {
          display: block;
          padding: 10px 0;
          background: #fff;
          position: relative;
          p {
            font-size: 14px;
            margin-bottom: 0;
            color: @textColor;
            display: block;
            text-align: right;
            padding-right: 40px;
            .elips;
          }
          i {
            color: @iconColor;
            position: absolute;
            &:first-child {
              right: 15px;
              top: 9px;
            }
            &:last-child {
              left: 15px;
              top: 9px;
            }
            &:hover {
              color: @iconHover;
            }
          }
          &::before {
            position: absolute;
            content: "";
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            transform-origin: center;
            border-bottom: 2px solid @green;
            transform: scale3d(0, 1, 1);
            transition: all 0.2s cubic-bezier(0, -0.22, 0.18, 1.06);
          }
          &:hover::before {
            transform: scale3d(1, 1, 1);
            transition: transform 0.3s;
          }
        }
        .subItem {
          transition: all 0.2s ease;
          position: absolute;
          right: 100%;
          left: -100%;
          top: 0;
          border-top: none;
          box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.4);
          z-index: 8;
          background-color: #fff;
          text-align: center;
          display: none;
          bottom: 0;
          width: 1140px - 250px;
          ul {
            min-width: 220px;
          }
        }
      }
    }
  }
  .categories-btn {
    &:hover {
      .categories-list {
        display: block;
        li.active {
          > a {
            &::before {
              transform: scale3d(1, 1, 1);
              transition: transform 0.3s;
            }
          }
          > .subItem {
            display: block;
          }
        }
      }
    }
  }
}

////mobile mode

@media screen and (max-width: 1200px) {
  .componenets-categories .categories-list ul li .subItem ul {
    min-width: 176px;
  }
  .componenets-categories .categories-list ul li .subItem {
    width: 710px;
  }
  .componenets-categories .categories-list {
    width: 180px;
  }
}
@media screen and (max-width: 992px) {
  .desktop-mode {
    display: none;
  }
  .mobile-mode {
    display: block;
    padding: 4px 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/categories/index.vue